import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import { TargetingSettingsContext, TargetingLevel } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import { isMSStoreAdsCampaign } from '@bingads-webui-campaign-react/ms-store-ads-common';
import physicalIntentOptions from '@bingads-webui-campaign-legacy/location-targets/viewmodel/physicalIntentOptions';

export class LocationTargetView extends DeterministicWrapperView {
  viewFactory({
    level,
    campaignId,
    adgroupId,
    criterions,
    showBidMode,
    isDSACampaign,
    isSmartShoppingCampaign,
    supportCashbackSettings = false,
    currentCampaign,
    currentAdGroup,
    perfMarker,
  }) {
    const scenario = this.getScenario(isSmartShoppingCampaign, level);
    this.supportCashbackSettings = supportCashbackSettings;
    const isAudienceCampaign = currentCampaign && (currentCampaign.CampaignType === 'Audience' || currentCampaign.CampaignType === 8);
    const hideAudience = isSmartShoppingCampaign ||
      (currentCampaign && isAudienceCampaign && scenario === 'adgroup-settings');
    const isMSStoreAdsGAWorkflow = isMSStoreAdsCampaign(currentCampaign);

    this.locationTargets = new TargetingSettingsContext.LocationTargets({
      campaignId,
      adgroupId,
      scenario,
      editCriterions: criterions,
      showBidMode,
      fromSettingsGrid: true,
      isDSACampaign,
      isForVNext: true,
      hideAudience,
      supportCashbackSettings,
      currentCampaign,
      currentAdGroup,
      perfMarker,
      showPhysicalIntentView: !isMSStoreAdsGAWorkflow && !isAudienceCampaign,
      physicalIntent: isMSStoreAdsGAWorkflow ? physicalIntentOptions.PeopleIn : undefined,
      popupIds: isMSStoreAdsGAWorkflow ? {
        Location: 'pop_BA_StoreAds_Location',
      } : undefined,
    });
    this.locationTargets.on('closeLocationEditor', () => this.trigger('closeLocationEditor'));
    return this.locationTargets;
  }

  getScenario(isSmartShoppingCampaign, level) {
    if (level !== TargetingLevel.Campaign) {
      return 'adgroup-settings';
    }
    if (isSmartShoppingCampaign) {
      return 'smart-shopping-campaign';
    }
    return 'campaign-settings';
  }

  setState({
    campaignId,
    adgroupId,
  }) {
    this.locationTargets.setCampaignId(campaignId);
    this.locationTargets.setAdGroupId(adgroupId);
    this.locationTargets.refreshLocationData();
    return this;
  }

  validate() {
    return this.locationTargets.validate();
  }

  save() {
    return this.locationTargets.checkIMAReachAndSave();
  }

  updatedCriterionsCount() {
    const criterions = this.locationTargets.getValues();
    return criterions.deletedLocations.length +
      criterions.locations.length + criterions.intent.length;
  }

  hasErrors() {
    const errors = this.locationTargets.viewmodel.errors();
    return errors && errors.length;
  }
}
